import React, { Component } from 'react';
import '../App.css';
import myHebcal from '../Codes/myHebcal';
import CalendarAPI from '../Codes/CalendarAPI';
import DateInput from './DateInput';
import DropdownCalendarName from './DropdownCalendarName';
import ImgLoading from '../Img/Rolling-38px.svg';
import {Line} from 'rc-progress';


class InputEvent extends Component {
    constructor(props){
        super(props);
        this.state={
            hebDate:undefined,
            date: undefined,
            eventDesc: "",
            to_year_number: 1,
            toCalendar:undefined,

            eventsAdded: 0,
            eventsNotAdded: 0,
            eventsExpected: 0
        }
        this.onInputUpdate=this.onInputUpdate.bind(this);
        this.pushEvent = this.pushEvent.bind(this);
    }

    setHebDate(_hebDate){
        this.setState({hebDate: _hebDate});
    }

    setToYear(_to_year_number){
        this.setState({to_year_number: _to_year_number});
    }

    setToCalendar(_calendar){
        console.log("set calendar");
        console.log(_calendar);
        this.setState({toCalendar: _calendar});
    }
    onInputUpdate(event){
        /*let day=this.state.day;
        let month=this.state.month;
        let year = this.state.year;
        if(event.target.id==="dayIn")
        {
            this.setState({day: event.target.value});
            day = event.target.value;
        }
        if(event.target.id==="monthIn")
        {
            this.setState({month: event.target.value});
            month = event.target.value;
        }
        if(event.target.id==="yearIn")
        {
            this.setState({year: event.target.value});
            year = event.target.value;
        }
        if(event.target.id==="to_year_number")
        {
            this.setState({to_year_number: event.target.value});
        }*/

        if(event.target.id==="eventDesc")
            this.setState({eventDesc: event.target.value});
        
    }


    /*pushEvent(){
        console.log(this.state.to_year_number);
        if(this.state.to_year_number)
        {
            this.setState({eventsExpected: myHebcal.yearDifference(this.state.hebDate, this.state.to_year_number)});
            myHebcal.loopFromYearToYear(this.state.hebDate, this.state.to_year_number, this.pushSingleEvent.bind(this));
        }
        else{
            this.setState({eventsExpected: 1});
            let date=this.state.hebDate.greg();;
            CalendarAPI.pushEvent(this.state.eventDesc, date, this.state.toCalendar, this.updateCount.bind(this));
        }
    }*/

    pushEvent(){
        console.log(this.state.to_year_number);
        if(this.state.to_year_number)
        {
            this.setState({eventsExpected: this.state.to_year_number, eventsAdded:0 , eventsNotAdded:0});
            let dates = myHebcal.loopFromYearToYear(this.state.hebDate, this.state.to_year_number);
            CalendarAPI.pushAllEvents(this.state.eventDesc, 
        this.state.toCalendar, dates, this.updateCount.bind(this));
        }
        
    }

    pushSingleEvent(georgianDate, allDatesToAdd, count, cb2){
        CalendarAPI.pushEvent(this.state.eventDesc+" "+(count+1), georgianDate, 
        this.state.toCalendar, allDatesToAdd, count, this.updateCount.bind(this), cb2);
    }

    updateCount(addedOrFailed){
        console.log("update");
        console.log(this.state.eventsAdded+this.state.eventsNotAdded);
        console.log(this.state.eventsExpected);
        console.log("update");
        if(this.state.eventsExpected===this.state.eventsAdded+this.state.eventsNotAdded+1){
            console.log(this.state.eventsAdded);
            let added = this.state.eventsAdded  +(addedOrFailed? 1 : 0);
            let notAdded= this.state.eventsNotAdded+ (addedOrFailed? 0 : 1);
            
            alert("הוספו "+added+" אירועים"+"\n"+(notAdded?"נכשלו להיווסף "+notAdded+" אירועים":""));
            this.setState({eventsAdded: 0, eventsNotAdded: 0, eventsExpected:0});
            this.props.updateFinished(true);
        }
        else{
            if(addedOrFailed){
                this.setState({eventsAdded: this.state.eventsAdded+1});
            }
            else{
                this.setState({eventsNotAdded: this.state.eventsNotAdded+1});
            }
        }
        
    }
    
    render(){
        return(
            <div>
                <header>
                <div className="row-main">
                    <div className="col-4">
                    <div className="sponser-logo">
                        <label className="sponser-logo">כרמל 6000</label><br/>
                        <label className="sponser-logo">בחסות רשת אמית</label>
                    </div>
                    </div>
                    <div className="col-4 flex-bottom">
                        <h3>לוח 6000</h3>
                    </div>
                    <div className="col-4">
                        <button className="btn btn-outline-dark" onClick={CalendarAPI.signOut}>התנתק</button>
                    </div>
                </div>
                <h4>הוספת  אירוע חוזר ליומן גוגל</h4>
            </header>
                <div className="flex-column-center">
                    <div className="">
                        
                        <DateInput setHebDate={this.setHebDate.bind(this)} setToYear={this.setToYear.bind(this)}/>
                        <div className="">
                            
                            <div className="col-12">
                                <input className="form-control input"  id="eventDesc" placeholder="שם האירוע" onChange={this.onInputUpdate} value={this.state.eventDesc} />
                            </div>
                            <DropdownCalendarName setToCalendar={this.setToCalendar.bind(this)} />
                        </div>
                        <div className="margin-top-10">
                            {
                                this.state.eventsExpected === this.state.eventsAdded + this.state.eventsNotAdded?
                                <button className="btn addbtn" onClick={this.pushEvent}>הוסף ליומן שלי</button>:
                                <Line percent={100*((this.state.eventsAdded+this.state.eventsNotAdded)/this.state.eventsExpected)} strokeWidth="4" strokeColor="#46A3DB" />
                            }   
                        </div>
                    </div>       
                </div>
                
           </div>
        );
    }
}

/*<img src={ImgLoading} alt="loading wheel"></img>*/
export default InputEvent;


// WEBPACK FOOTER //
// ./src/components/InputEvent.js